import { bindable, capture } from "aurelia";

@capture((attrs) => attrs !== "id" && attrs !== "label" && attrs !== "validate")
export class InputComponent {
  public id: string = crypto.randomUUID();

  @bindable public label: string;
  @bindable public validate: boolean = false;
}
